<template>
    <div class="separator"></div>
    <div class="footerSection">
        <div class="footer">
            <div class="footerContent">
                <div class="logoFooter">
                    <router-link to="/" class="logoImg">
                        <img src="../assets/logos/solutions-service-livraison.webp" alt="" loading="lazy"/>
                    </router-link>
                </div>
                <div class="contactFooter">
                    <span class="footerTitles">Contact</span>
                    <ul>
                        <li>06 58 56 80 83</li>
                        <li>contact@gma-logistics.com</li>
                        <li>501 Av. de la Couronne des Prés <br>78680 Epône</li>
                    </ul>
                </div>
                <div class="contactFooter">
                    <span class="footerTitles">{{ $t('footer.network') }} </span>
                    <ul>
                        <li>
                            <a class="network" href="">
                                <div class="newtorkIcon">
                                    <img src="../assets/network/icon_instagram.png" alt="Logo Instagram" loading='lazy' />
                                </div>
                                <div>Instagram</div>
                            </a>
                        </li>
                        <li>
                            <a class="network" href="https://www.linkedin.com/company/gma-logistics/about/" target="_blank">
                                <div class="newtorkIcon">
                                    <img src="../assets/network/icon_linkedin.png" alt="Logo LinkedIn" loading='lazy' />
                                </div>
                                <div>LinkedIn</div>
                            </a>
                        </li>
                        <!-- <li>
                            <a class="network" href="" >
                                <div class="newtorkIcon">
                                    <img src="../assets/network/icon_tiktok.png" alt="" />
                                </div>
                                <div>Réseau</div>
                            </a>
                        </li> -->
                    </ul>
                </div>
                <div class="politicsFooter">
                    <span class="footerTitles">{{ $t('footer.link.title') }}</span>
                    <ul>
                        <li class="politicsLinksLi">
                            <router-link to="/politique-de-confidentialite" class="politicsLinks">{{ $t('footer.link.politics') }}</router-link></li>
                        <li class="politicsLinksLi"><router-link to="/mentions-legales" class="politicsLinks">{{ $t('footer.link.legal') }}</router-link></li>
                        <!-- <li class="politicsLinksLi"><a class="politicsLinks" href="">link ??</a></li> -->
                    </ul>
                </div>
            </div>
        </div>
        <div class="copyright">©2026 GMA - Tous droits réservés</div>
    </div>
</template>

<style scoped>
.separator {
    position: relative;
    margin-top: 55px;
}
.separator::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    border-top: 1px solid #e91e63;
}
.footerSection {
    width: 100%;
}
.footer {
    display: flex;
    padding: 80px 30px 0 30px;
    text-align: left;
    max-width: 1440px;
    margin: auto;
}
.footerContent {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.logoFooter, .contactFooter, .socialNetwork, .politicsFooter {
    display: flex;
    flex-direction: column;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    align-self: center;
}
.logoImg {
    width: 200px;
    height: auto;
}
.logoImg > img, .newtorkIcon > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.copyright {
    font-size: 12px;
    padding: 40px;
}
.newtorkIcon {
    width: 20px;
    height: 20px;
    margin-right: 15px;
}
.network {
    display: flex;
    text-decoration: none;
    color: #212121;
}
ul {
    text-align: left;
    padding-inline-start: 0;
}
li {
    list-style-type: none;
    padding: 5px 0;
}
.politicsLinks {
    text-decoration: none;
    color: #212121;
}
a:hover, .politicsLinksLi:hover {
    transform: translateY(-3px);
    transition: transform 0.3s ease;
}
@media screen and (min-width: 2000px ) {
    .footerSection {
        max-width: 1440px;
        margin: auto;
    }

}
@media screen and (max-width: 750px ) {
    .footerContent {
        flex-direction: column;
        text-align: center;
    }
    .logoFooter, .contactFooter, .socialNetwork, .politicsFooter {
        margin: auto;
        padding: 10px 0;
    }
    ul {
        text-align: center;
    }
}
</style>